import { Card, CardContent, Grid } from '@mui/material';
import ButtonBack from '../Common/Breadcrumb/ButtonBack';

export const Ayuda = () => {
  return (
    <Grid container spacing={1}>
      <ButtonBack />
      <Grid item xs={12}>
        <Card sx={{ width: '100%' }}>
          <CardContent>
            <iframe
              title='Preview'
              src='https://www.iosper.gov.ar/ManualdeUsuario_%20MIIOSPER.pdf'
              width={'100%'}
              height={500}
              loading='lazy'
              allowFullScreen={true}
              style={{
                border: 'none',
                height: 'calc(100vh - 200px)',
              }}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
